<div class="overflow-y-auto">
	<app-teranet-pin-view
		*ngIf="hasPins$ | async"
		class="mb-10 block"
	></app-teranet-pin-view>

	<div class="px-10">
		<app-teranet-writ [hideButton]="true"></app-teranet-writ>
	</div>
</div>

<ui-content-footer
	[primaryAction]="{ text: 'Continue', action: next }"
	[secondaryAction]="{ text: 'Back', action: back }"
	[testHook]="testHooks.ContentFooter"
></ui-content-footer>
